//
//  DocumentationLegacyPageBlockGuideline.ts
//  Pulsar Language
//
//  Created by Jiri Trecak.
//  Copyright © 2021 Supernova. All rights reserved.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Imports
import { FigmaComponentPreviewContainerSize } from "../../enums/SDKFigmaComponentPreviewContainerSize";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class DocumentationLegacyPageBlockSelectedFigmaComponent {
    constructor(model) {
        var _a, _b;
        this.figmaComponentId = model.figmaComponentId;
        this.selectedComponentProperties = (_a = model.selectedComponentProperties) !== null && _a !== void 0 ? _a : [];
        this.selectedComponentVariants = (_b = model.selectedComponentVariants) !== null && _b !== void 0 ? _b : {};
    }
}
export class DocumentationLegacyPageBlockFigmaComponentsConfig {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        var _a, _b, _c, _d, _e;
        this.showComponentName = (_a = model.showComponentName) !== null && _a !== void 0 ? _a : false;
        this.showComponentDescription = (_b = model.showComponentDescription) !== null && _b !== void 0 ? _b : false;
        this.showPropertyList = (_c = model.showPropertyList) !== null && _c !== void 0 ? _c : false;
        this.previewOrderIds = (_d = model.previewOrderIds) !== null && _d !== void 0 ? _d : [];
        this.previewContainerSize =
            model.previewContainerSize === "NaturalHeight"
                ? FigmaComponentPreviewContainerSize.naturalHeight
                : FigmaComponentPreviewContainerSize.centered;
        this.previewContainerHeight = (_e = model.previewContainerHeight) !== null && _e !== void 0 ? _e : null;
        this.backgroundColor = model.backgroundColor;
    }
}
